angular.module('skeyenoteWebApp').service('baseUrlSrv', BaseUrlService);

function BaseUrlService() {
  this.getPort = function() {
    let port = Number(location.port);
    if (!port) {
      port = 80;
      if (location.protocol === 'https:') {
        port = 443;
      }
    }
    // Exception for when running locally via grunt
    if (port === process.env.WEB_PORT) {
      port = process.env.SERVER_PORT;
    }
    return port;
  };

  this.getWebsocketUrl = function() {
    let wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
    return wsProtocol + '//' + location.hostname + ':' + this.getPort() +
      skipTrailingSlash(location.pathname) + '/ws';
  };

  this.getBase = function() {
    return location.protocol + '//' + location.hostname + ':' + this.getPort() + location.pathname;
  };

  this.getRestApiBase = function() {
    return skipTrailingSlash(this.getBase()) + '/api';
  };

  const skipTrailingSlash = function(path) {
    return path.replace(/\/$/, '');
  };
}
